import { render } from "./in-new-standard.vue?vue&type=template&id=fc04c02e&scoped=true"
import script from "./in-new-standard.vue?vue&type=script&lang=js"
export * from "./in-new-standard.vue?vue&type=script&lang=js"

import "./in-new-standard.vue?vue&type=style&index=0&id=fc04c02e&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc04c02e"]])

export default __exports__